import { render, staticRenderFns } from "./EventCorrespondenceTab.vue?vue&type=template&id=03b33ecc&scoped=true"
import script from "./EventCorrespondenceTab.vue?vue&type=script&lang=js"
export * from "./EventCorrespondenceTab.vue?vue&type=script&lang=js"
import style0 from "./EventCorrespondenceTab.vue?vue&type=style&index=0&id=03b33ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b33ecc",
  null
  
)

export default component.exports